// TopBar Configuration Constants
export const TOPBAR_CONFIG = {
  // Brand Configuration
  BRAND: {
    name: 'TheMaithil',
    icon: '🕉️', // Om symbol for spiritual services
    logoImage: '/themaithil_logo.png',
    color: 'text-orange-600',
    logoSize: {
      mobile: 'text-2xl',
      desktop: 'sm:text-3xl'
    },
    brandSize: {
      mobile: 'text-sm font-bold',
      desktop: 'sm:text-xl font-bold'
    },
    hideOnMobile: 'block',
    gradient: 'bg-gradient-to-r from-orange-600 to-orange-500 bg-clip-text text-transparent'
  },

  // Layout Configuration
  LAYOUT: {
    height: 'h-16',
    zIndex: 'z-50',
    maxWidth: 'max-w-7xl',
    padding: {
      mobile: 'px-4',
      tablet: 'sm:px-6',
      desktop: 'lg:px-8'
    },
    background: 'bg-white backdrop-blur-sm bg-opacity-95',
    border: 'border-b border-gray-200 shadow-sm',
    position: 'sticky top-0'
  },

  // Search Configuration
  SEARCH: {
    placeholder: 'Search for spiritual services...',
    width: {
      large: 'w-64',
      extraLarge: 'xl:w-80'
    },
    visibility: {
      desktop: 'hidden lg:flex',
      mobile: 'lg:hidden'
    },
    styling: {
      background: 'bg-orange-50',
      focus: 'focus:bg-white focus:border-orange-300 focus:ring-1 focus:ring-orange-300',
      border: 'border border-gray-200 rounded-md',
      padding: 'pl-10 pr-3 py-2',
      text: 'text-sm',
      placeholder: 'placeholder-gray-500'
    }
  },

  // Location Configuration
  LOCATION: {
    defaultText: 'Select your city',
    visibility: 'hidden lg:flex',
    maxWidth: 'max-w-32',
    dropdownWidth: 'w-64',
    sectionTitle: 'Spiritual Cities'
  },

  // Cart Configuration
  CART: {
    maxDisplayCount: 99,
    badgeColors: 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg',
    badgeSize: 'min-w-[20px] h-5 text-xs',
    badgePosition: 'absolute -top-1 -right-1',
    badgeBorder: 'border-2 border-white'
  },

  // User Menu Configuration
  USER_MENU: {
    dropdownWidth: 'w-48',
    welcomeMessage: {
      loggedIn: {
        title: (name) => name || 'Devotee',
        subtitle: 'email'
      },
      guest: {
        title: 'Welcome',
        subtitle: 'Join our community'
      }
    },
    signupSection: {
      title: 'Get Started',
      titleStyle: 'text-xs text-orange-600 font-semibold uppercase tracking-wide mb-2'
    }
  },

  // Colors and Themes
  COLORS: {
    primary: 'orange-600',
    primaryHover: 'orange-700',
    primaryLight: 'orange-50',
    secondary: 'gray-600',
    secondaryHover: 'gray-900',
    text: 'gray-700',
    textLight: 'gray-500',
    textDark: 'gray-900',
    border: 'gray-200',
    borderLight: 'gray-100',
    // Enhanced dropdown colors
    dropdownBorder: 'orange-100',
    dropdownText: 'gray-800',
    dropdownTextHover: 'orange-800',
    dropdownBackground: 'white',
    dropdownBackgroundHover: 'orange-50'
  },

  // Hover Effects
  HOVER_EFFECTS: {
    logo: 'hover:opacity-80 transition-opacity duration-200',
    button: 'hover:text-orange-600 hover:bg-gradient-to-r hover:from-orange-50 hover:to-orange-100 hover:shadow-md',
    dropdown: 'hover:bg-gradient-to-r hover:from-orange-50 hover:to-orange-100 hover:text-orange-700 hover:shadow-sm',
    location: 'hover:text-gray-900 hover:bg-gradient-to-r hover:from-gray-50 hover:to-gray-100 hover:shadow-sm'
  },

  // Transitions
  TRANSITIONS: {
    default: 'transition-all duration-300 ease-in-out',
    all: 'transition-all duration-200 ease-in-out',
    fast: 'transition-all duration-150 ease-in-out'
  },

  // SVG Icons and Graphics
  ICONS: {
    search: {
      viewBox: '0 0 20 20',
      path: 'M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z',
      size: 'w-4 h-4',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    },
    searchMobile: {
      viewBox: '0 0 20 20',
      path: 'M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z',
      size: 'w-5 h-5',
      fillRule: 'evenodd'
    },
    location: {
      viewBox: '0 0 20 20',
      path: 'M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z',
      size: 'w-4 h-4',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    },
    chevronDown: {
      viewBox: '0 0 20 20',
      path: 'M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z',
      size: 'w-4 h-4',
      fillRule: 'evenodd'
    },
    cart: {
      viewBox: '0 0 24 24',
      path: 'M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
      modernPath: 'M5 7h13.09l-1.5 6H8.31L5 7zM3 3v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H3z M7 18c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z M17 18c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z',
      size: 'w-6 h-6',
      strokeWidth: 1.5,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      fill: 'currentColor'
    },
    user: {
      viewBox: '0 0 24 24',
      path: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
      size: 'w-5 h-5',
      strokeWidth: 1.5,
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }
  },

  // Component Styling
  COMPONENTS: {
    searchInput: {
      iconPosition: 'absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none',
      iconColor: 'text-gray-400',
      container: 'relative w-full'
    },
    dropdown: {
      container: 'absolute top-full left-0 mt-1 bg-white rounded-lg shadow-lg py-2 z-50',
      userContainer: 'absolute right-0 mt-2 bg-white rounded-lg shadow-lg py-1 z-50 border border-gray-200 min-w-[200px] max-w-[220px] overflow-hidden',
      sectionDivider: 'my-1 border-gray-100',
      userInfo: 'px-3 py-2 border-b border-gray-100',
      menuItem: 'w-full text-left px-3 py-2 text-sm font-medium flex items-center transition-colors duration-150 hover:bg-orange-50 hover:text-orange-700',
      signupContainer: 'px-3 py-1',
      signupItem: 'w-full text-left px-3 py-2 text-sm font-medium mb-1 transition-colors duration-150 hover:bg-orange-50 hover:text-orange-700'
    },
    button: {
      base: 'p-3 rounded-xl shadow-sm border border-transparent hover:shadow-lg',
      search: 'p-2 rounded-lg mr-2 shadow-sm',
      location: 'flex items-center px-4 py-2.5 text-sm font-medium rounded-xl shadow-sm border border-gray-200 bg-white'
    },
    layout: {
      header: 'flex items-center justify-between',
      container: 'mx-auto',
      logoContainer: 'flex-shrink-0 flex items-center',
      logoButton: 'flex items-center',
      logoIconContainer: 'flex items-center justify-center',
      spacer: 'flex-1',
      searchContainer: 'flex-shrink-0 mr-4',
      actionsContainer: 'flex items-center space-x-2'
    },
    typography: {
      fontBold: 'font-bold',
      fontMedium: 'font-medium',
      textXs: 'text-xs',
      textSm: 'text-sm',
      textBase: 'text-base'
    },
    spacing: {
      marginRight3: 'mr-3',
      marginRight2: 'mr-2',
      marginLeft1: 'ml-1',
      paddingX1: 'px-1'
    },
    display: {
      flex: 'flex',
      block: 'block',
      relative: 'relative',
      absolute: 'absolute'
    },
    alignment: {
      itemsCenter: 'items-center',
      justifyCenter: 'justify-center',
      textLeft: 'text-left'
    },
    misc: {
      roundedFull: 'rounded-full',
      truncate: 'truncate',
      zIndex10: 'z-10',
      cursorPointer: 'cursor-pointer',
      cursorDefault: 'cursor-default',
      focusOutline: 'focus:outline-none',
      pointerEventsNone: 'pointer-events-none',
      uppercase: 'uppercase',
      trackingWide: 'tracking-wide'
    }
  }
};

// Popular Locations Configuration
export const LOCATIONS_CONFIG = {
  POPULAR_LOCATIONS: [
    'Mumbai, Maharashtra',
    'Delhi, NCR', 
    'Bangalore, Karnataka',
    'Pune, Maharashtra',
    'Chennai, Tamil Nadu',
    'Hyderabad, Telangana',
    'Kolkata, West Bengal',
    'Ahmedabad, Gujarat',
    'Jaipur, Rajasthan',
    'Lucknow, Uttar Pradesh',
    'Varanasi, Uttar Pradesh',
    'Haridwar, Uttarakhand',
    'Rishikesh, Uttarakhand',
    'Ujjain, Madhya Pradesh',
    'Nashik, Maharashtra'
  ],
  
  // Group locations by regions for better organization
  REGIONS: {
    SPIRITUAL_CITIES: [
      'Varanasi, Uttar Pradesh',
      'Haridwar, Uttarakhand',
      'Rishikesh, Uttarakhand',
      'Ujjain, Madhya Pradesh',
      'Nashik, Maharashtra'
    ],
    METRO_CITIES: [
      'Mumbai, Maharashtra',
      'Delhi, NCR',
      'Bangalore, Karnataka',
      'Chennai, Tamil Nadu',
      'Hyderabad, Telangana',
      'Kolkata, West Bengal'
    ],
    OTHER_CITIES: [
      'Pune, Maharashtra',
      'Ahmedabad, Gujarat',
      'Jaipur, Rajasthan',
      'Lucknow, Uttar Pradesh'
    ]
  }
};

// User Menu Items Configuration
export const USER_MENU_CONFIG = {
  MENU_ITEMS: [
    { 
      id: 'login', 
      label: 'Login', 
      action: 'login',
      icon: '👤',
      showWhen: 'guest' // Show only when not logged in
    },
    { 
      id: 'signup', 
      label: 'Sign Up', 
      action: 'signup',
      icon: '✨',
      showWhen: 'guest' // Show only when not logged in
    },
    { 
      id: 'profile', 
      label: 'My Profile', 
      action: 'profile',
      icon: '👤',
      showWhen: 'authenticated' // Show only when logged in
    },
    { 
      id: 'bookings', 
      label: 'My Bookings', 
      action: 'bookings',
      icon: '📅',
      showWhen: 'authenticated'
    },
    { 
      id: 'orders', 
      label: 'Order History', 
      action: 'orders',
      icon: '📋',
      showWhen: 'authenticated'
    },
    { 
      id: 'favorites', 
      label: 'Saved Pandits', 
      action: 'favorites',
      icon: '💛',
      showWhen: 'authenticated'
    },
    { 
      id: 'settings', 
      label: 'Settings', 
      action: 'settings',
      icon: '⚙️',
      showWhen: 'authenticated'
    }
  ],

  SIGNUP_OPTIONS: []
};

// Default Props Configuration
export const TOPBAR_DEFAULTS = {
  // Display Options
  showLogo: true,
  showLocation: true,
  showSearch: true,
  showUserIcon: true,
  showCartIcon: true,

  // Data Props
  cartCount: 0,
  isLoggedIn: false,
  userInfo: null,

  // Styling Props
  className: '',
  containerMaxWidth: TOPBAR_CONFIG.LAYOUT.maxWidth,

  // Event Handlers (will be overridden by props)
  onLocationClick: null,
  onUserClick: null,
  onCartClick: null,
  onSearch: null,
  onSignupUser: null,
  onSignupPandit: null,
  onLogoClick: null
};

// Responsive Configuration
export const TOPBAR_RESPONSIVE = {
  BREAKPOINTS: {
    // Logo visibility
    LOGO_TEXT: 'hidden sm:block',
    
    // Search visibility
    SEARCH_DESKTOP: 'hidden lg:flex',
    SEARCH_MOBILE: 'lg:hidden',
    
    // Location visibility
    LOCATION: 'hidden lg:flex',
    
    // Spacing adjustments
    SPACING: {
      logo: 'space-x-2 sm:space-x-3',
      actions: 'space-x-1 sm:space-x-2'
    }
  }
};
